<template>
    <div>
        <div class="share-btn" :class="theme">
            <a
                class="share-item"
                v-if="shares.twitterHref"
                target="_blank"
                :href="shares.twitterHref"
                @click="itemClick"
                rel="noopener noreferrer"
            >
                <span class="iconfont twitter icon-newtwitter-round"></span>
            </a>
            <a
                class="share-item"
                v-if="shares.facebookHref"
                target="_blank"
                :href="shares.facebookHref"
                @click="itemClick"
                rel="noopener noreferrer"
            >
                <span class="iconfont facebook icon-facebook1"></span>
            </a>
            <a
                class="share-item"
                v-if="shares.gmailHref"
                :href="shares.gmailHref"
                @click="itemClick"
                rel="noopener noreferrer"
            >
                <span class="iconfont gmail icon-email-round"></span>
            </a>
            <a
                class="share-item"
                v-if="shares.linkedinHref"
                target="_blank"
                :href="shares.linkedinHref"
                @click="itemClick"
                rel="noopener noreferrer"
            >
                <span class="iconfont linkedin icon-linkedin-round"></span>
            </a>
        </div>
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';

export default {
    data: function() {
        return {};
    },
    props: {
        shares: {
            required: true
        },
        listingId: {
            required: false
        },
        theme: {
            type: String,
            default: 'classic'
        }
    },
    computed: {
        ...mapState({
            "info": store => store.listingDetail?.info || {}
        }),
    },
    methods: {
        itemClick: function() {
            this.$EventBus.$emit('siteTrack', {
                listingId: this.listingId,
                trackType: 'shares_property_info',
                listingUrl: this.info?.detailUrl ?? this.info?.detailLink,
                address: this.info?.address,
                listingType: 1 // 1 - active listing, 0 - sold listing
            });
        }
    }
};
</script>
<style lang="scss">
.share-btn {
    display: flex;
    box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);
    border: solid 1px #ebecf0;
    background-color: #ffffff;
    padding: 20px;
    position: relative;
    &::before {
        content: '';
        position: absolute;
        top: -6px;
        left: 50%;
        width: 10px;
        height: 10px;
        background: #fff;
        border: solid 1px #ebecf0;
        border-left: none;
        border-bottom: none;
        transform: translateX(-50%) rotate(-45deg);
        transform-origin: center;
    }
    .share-item {
        margin-right: 20px;
        &:last-child {
            margin-right: 0;
        }
        .iconfont {
            cursor: pointer;
            font-size: 30px;
            &.twitter:hover {
                color: #53a9ea;
            }
            &.facebook:hover {
                color: #4b67a0;
            }
            &.gmail:hover {
                color: #ef605d;
            }
            &.linkedin:hover {
                color: #007ab9;
            }
        }
    }
    &.classic {
        .share-item {
            color: #c8c9ca;
        }
    }
    &.standard {
        .share-item {
            color: #cfd0d5;
        }
    }
    &.fashion {
        .share-item {
            color: #adb9d1;
        }
    }
}
</style>
